
<template>
  <div class="col s12 change-order">
    <p></p>
    <div class="col s12 m12 l8" style="" id="middle" >
      <div id='clubBoard' style="Width: auto; height: 300px" :class="classboard"></div>
    </div>    
    <div class="col s12 m12 l4" style="text-align: center" v-if="club.createby">
      <div class="">
        <blockquote><h6 id='eval' class="flat-text-header hello" style="text-align: center"></h6></blockquote>
        <div id="pgnComment" style="display: none;"></div>
        <!-- <h5 class="flat-text-header">{{ $t("clubs.createBy") }} </h5>
        {{club.createby}}
        <h5 class="flat-text-header">{{ $t("clubs.date") }}</h5>
        {{club.created | moment 'DD/MM/YYYY, h:mm:ss a'}}-->
        <h5 class="flat-text-header">{{ $t("clubs.played") }}: {{ $t("clubs.color." + turn) }}</h5>
        <div>
          <h6 class="flat-text-header">{{ $t("clubs.movs") }}</h6>
          <blockquote class="chip pulse">{{numMoves}}</blockquote>
        </div>
        <!-- <h6 class="flat-text-header">Tiempo</h6>-->
        <blockquote class="chip pulse purple darken-4" style="text-align: left; font-size: large;overflow: hidden; white-space:nowrap; text-overflow:ellipsis;color:white">
                Faltan <span class="" style=""><b>{{ times | timeBoard}}</b> de {{timeMove | timeBoard }}</span>
        </blockquote>
        <div>
          <h3>{{ $t("clubs.lost") }}</h3>
          <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4"
             @click="reintent()"
          >
            {{ $t("clubs.reintent") }}
          </a>
        </div>
        <div slot="actions">
          Difultad:  <blockquote class="chip pulse">{{ 100 - Math.round(club.corrects * 100 / club.intents) }}%</blockquote>
          <!-- <blockquote class="chip pulse"><span>Aciertos ({{club.corrects}})</span></blockquote>
          <blockquote class="chip pulse"><span>Intentos ({{club.intents}})</span></blockquote>-->
        </div>
         
        <div>
          <div class="row">
            <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" @click="pista()">pista</a>
          </div>
          <div class="row">
            <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" @click="resultado()">resultado</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
// import Chessground from 'chessground'
import Chess from 'chess.js'
import toast from 'vue-material-components'
// import Garbochess from '../../services/garbochess.min.js'
import EngineGame from '../../services/enginegame.min.js'
import ClubService from '../../services/club'
import Store from '../../services/lstorage'
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
window.pgnBoardBase = 0
var timesColor = 0

export default {
  name: 'clubChess',
  props: {
    club: {
      type: Object
    },
    classboard: {
      type: String
    },
    nextClub: {
      type: Function,
      required: false,
      'default': function () {
        return false
      }
    }
  },
  data () {
    return {
      mate: false,
      numMoves: 1000,
      timeMove: 120,
      handMoves: 0,
      userColor: 'white',
      ground: 1,
      turn: 'white',
      stockfish: {},
      chess: new Chess(),
      chessPgn: new Chess(),
      stylesBoard: stylesBoard,
      times: 120,
      resultPractica: '',
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        })
    }
  },
  mixins: [
    toast
  ],
  methods: {
    onResize (event) {
      document.body.dispatchEvent(new window.Event('chessground.resize'))
    },
    chessToDests (chess) {
      var dests = {}
      chess.SQUARES.forEach(function (s) {
        var ms = chess.moves({square: s, verbose: true})
        if (ms.length) dests[s] = ms.map(function (m) { return m.to })
      })
      return dests
    },
    resolveClub (parms) {
      ClubService.resolve(this, parms).then(function (response) {
        // window.alert('bien')
      }, function (response) {
        // window.alert('mal')
      })
    },
    chessToColor (chess) {
      var t = chess.turn()
      var turn = (t === 'w') ? 'white' : 'black'
      this.turn = turn
      return turn
    },
    countDown () {
      if (isNaN(this.timeMove) === false) {
        this.times = this.timeMove
      } else {
        this.times = 120
      }
      clearInterval(timesColor)
      timesColor = setInterval(function () {
        this.times = this.times - 1
        if (this.times <= 0) {
          clearInterval(timesColor)
          this.times = 0
          this.onMove(-1, -1)
          this.mate = false
          this.numMoves = 0
        }
      }.bind(this), 1000)
    },
    pistaNext () {
      this.club.startPlay = 1
      var moves = window.pgnBoardBase.getPgn().getMoves()
      // window.alert(this.club.feninit)
      for (var i = 0; i < moves.length; i++) {
        var fen = moves[i].fen
        if (fen === this.club.feninit) {
          // window.alert(this.club.startPlay)
          break
        }
        this.club.startPlay++
      }
      if (this.club.startPlay > moves.length) {
        this.club.startPlay = 0
      }
      if (this.club.pgn !== undefined && this.club.pgn.length > 0) {
        var numGetMove = this.club.startPlay + this.handMoves
        // window.alert(this.club.startPlay + this.handMoves)
        // window.alert('.' + this.chess.history()[this.handMoves] + ' ' + window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation + '.')
        if (window.pgnBoardBase.getPgn().getMove(numGetMove) !== undefined) {
          this.ground.setAutoShapes({
            orig: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
            dest: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
            brush: 'yellow',
            modifiers: {lineWidth: 5}
          })
        }
      }
    },
    resultadoNext () {
      this.countDown()
      this.club.startPlay = 1
      var moves = window.pgnBoardBase.getPgn().getMoves()
      // window.alert(this.club.feninit)
      for (var i = 0; i < moves.length; i++) {
        var fen = moves[i].fen
        if (fen === this.club.feninit) {
          // window.alert(this.club.startPlay)
          break
        }
        this.club.startPlay++
      }
      if (this.club.startPlay > moves.length) {
        this.club.startPlay = 0
      }
      if (this.club.pgn !== undefined && this.club.pgn.length > 0) {
        var numGetMove = this.club.startPlay + this.handMoves
        // window.alert(this.club.startPlay + this.handMoves)
        // window.alert('.' + this.chess.history()[this.handMoves] + ' ' + window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation + '.')
        this.onMove(window.pgnBoardBase.getPgn().getMove(numGetMove).from, window.pgnBoardBase.getPgn().getMove(numGetMove).from)
        if (window.pgnBoardBase.getPgn().getMove(numGetMove) !== undefined) {
          this.ground.setAutoShapes({
            orig: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
            dest: window.pgnBoardBase.getPgn().getMove(numGetMove).to,
            brush: 'yellow',
            modifiers: {lineWidth: 5}
          })
        }
      }
    },
    onMove (orig, dest) {
      // window.alert('move')
      this.ground.setAutoShapes({
        orig: '-1',
        dest: '-1',
        brush: 'yellow',
        modifiers: {lineWidth: 5}
      })
      this.numMoves --
      this.chess.move({
        from: orig,
        to: dest,
        promotion: 'q'
      })
      this.ground.move(orig, dest)
      this.ground.set({
        fen: this.chess.fen(),
        turnColor: this.chessToColor(this.chess),
        movable: {
          color: this.chessToColor(this.chess),
          dests: this.chessToDests(this.chess)
        },
        animation: {
          enabled: true,
          duration: 1000
        },
        highlight: {
          lastMove: true,       // add last-move class to squares
          check: true          // add check class to squares
        },
        drawable: {
          enabled: true,
          visible: true
        }
      })
      this.club.startPlay = 1
      var moves = window.pgnBoardBase.getPgn().getMoves()
      // window.alert(JSON.stringify(moves))
      for (var i = 0; i < moves.length; i++) {
        var fen = moves[i].fen
        if (this.club.feninit !== undefined && fen === this.club.feninit) {
          // window.alert(this.club.startPlay)
          break
        }
        this.club.startPlay++
      }
      if (this.club.startPlay > moves.length) {
        this.club.startPlay = 0
      }
      if (this.club.pgn !== undefined && this.club.pgn.length > 0 && !this.club.type.startsWith('Practica')) {
        var numGetMove = this.club.startPlay + this.handMoves
        // window.alert(JSON.stringify(window.pgnBoardBase.getPgn().getMove(numGetMove)))
        // window.alert('.' + this.chess.history()[this.handMoves] + ' ' + window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation + '.')
        if (this.chess.history()[this.handMoves] !== window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation) {
          // window.alert('pierdes')
          this.numMoves = 0
          this.mate = false
          // this.ground.stop()
          this.resolveClub({_id: this.club._id, resolve: this.mate ? 1 : 0})
          clearInterval(timesColor)
        } else if (this.numMoves <= 0) {
          this.mate = this.chess.history()[this.handMoves] === window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation
          // this.ground.stop()
          this.resolveClub({_id: this.club._id, resolve: this.mate ? 1 : 0})
          clearInterval(timesColor)
        } else {
          // this.movePC(this.turn)
          orig = window.pgnBoardBase.getPgn().getMove(numGetMove + 1).from
          dest = window.pgnBoardBase.getPgn().getMove(numGetMove + 1).to
          // this.onMove(sfrom, sto)
          this.numMoves --
          this.chess.move({
            from: orig,
            to: dest,
            promotion: 'q'
          })
          this.ground.move(orig, dest)
          this.ground.set({
            fen: this.chess.fen(),
            turnColor: this.chessToColor(this.chess),
            movable: {
              color: this.chessToColor(this.chess),
              dests: this.chessToDests(this.chess)
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            drawable: {
              enabled: true,
              visible: true
            }
          })
          this.handMoves++
        }
      } else {
        this.resultPractica = ''
        this.movePC(this.turn)
        this.numMoves = 1
        if (this.isFinish(this.chess)) {
          clearInterval(timesColor)
          if (this.chess.in_checkmate()) {
            this.resultPractica = 'Jaque mate'
            this.toast('Jaque mate', 2000)
            this.mate = this.chess.turn() === this.turn
          } else if (this.chess.in_draw()) {
            this.toast('Tablas', 2000)
            this.resultPractica = 'Tablas'
          } else {
            this.mate = true
          }
          this.numMoves = 0
        }
        /* if (this.numMoves <= 0) {
          if (true * this.club.type === 'Tactic' || this.club.type === 'Aperturas' || this.club.type === 'Finales' || this.club.type === 'Estrategia'*) {
            // verificar que fen actual es la esperada
            // console.log(this.club.fenfinish, this.ground.getFen())
            // window.alert(this.ground.getFen() + '\n' + this.club.fenfinish.split(' ')[0])
            this.mate = this.club.fenfinish.split(' ')[0] === this.ground.getFen()
          } else {
            this.mate = this.isFinish(this.chess)
          }
          this.ground.stop()
          this.resolveClub({_id: this.club._id, resolve: this.mate ? 1 : 0})
        } else {
          /* var PgnNew = this.club.pgn.split('"]').join('"]\n')
          PgnNew = PgnNew.split('{}').join('')
          // window.alert(PgnNew)
          this.chessPgn.load_pgn(PgnNew)
          // window.alert(this.chessPgn.moves())
          // window.alert(this.chess.history()) *
          this.movePC(this.turn)
          if (this.isFinish(this.chess)) {
            // window.alert('this.isFinish')
          }
        } */
      }
      this.handMoves++
    },
    /* PcIngeniesMove (move) {
      var from = move & 0xFF
      var to = (move >> 8) & 0xFF
      var sfrom = Garbochess.FormatSquare(from)
      var sto = Garbochess.FormatSquare(to)
      this.onMove(sfrom, sto)
    },*/
    PcIngeniesMoveStockfish (move) {
      var from = move.from
      var to = move.to
      // window.alert(from)
      this.onMove(from, to)
    },
    movePC (turn) {
      if (turn !== this.userColor) {
        setTimeout(function () {
          this.pcMove(this.chess.fen())
        }.bind(this), 200)
      }
    },
    pcMove (fen) {
      this.stockfish.setPlayerColor(this.orientation)
      // var white = parseFloat(this.time.white) * 1000
      // var black = parseFloat(this.time.black) * 1000
      // var incremento = parseFloat(this.time.incremento) * 1000
      // this.stockfish.setTime(parseFloat(this.time.white), this.time.incremento)
      // this.toast('<span>Deja que piense</span>', 2000)
      this.stockfish.prepareMove(fen, '', this.PcIngeniesMoveStockfish, 1000, 1000, 0, 0)
      /* if (this.club._id) {
        // use chess moves
        // this.makeRandomMove()
        Garbochess.InitializeFromFen(fen)
        Garbochess.Search(this.PcIngeniesMove, 5, null)
      } else {
        // use garbochess ingenie (dando problemas con los flags)
        Garbochess.InitializeFromFen(fen)
        Garbochess.Search(this.PcIngeniesMove, 5, null)
      }*/
    },
    makeRandomMove () {
      // window.alert('makeRandomMove')
      var possibleMoves = this.chess.moves({
        verbose: true
      })
      var randomIndex = Math.floor(Math.random() * possibleMoves.length)
      var move = possibleMoves[randomIndex]
      var from = move.from
      var to = move.to
      this.onMove(from, to)
    },
    hasBody (pgn) {
      var ret = false
      var newlineChar = '\r?\n'
      var lines = pgn.split(new RegExp(newlineChar))
      for (var i = 0; i < lines.length; i++) {
        // window.alert(lines[i])
        var linea = lines[i].trim()
        if (linea.length > 0 && linea[0] !== '['/* && lines[i].includes('.') */ && linea[0] !== '*') {
          // window.alert(linea)
          ret = true
          break
        }
      }
      return ret
    },
    parse_pgn_header (header) {
      var newlineChar = '\r?\n'
      var headerObj = {}
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0 && value.length > 0 && key !== value) {
          headerObj[key] = value
        }
      }
      return headerObj
    },
    loadClub (fen) {
      try {
        if (this.club.timemove === undefined) {
          this.club.timemove = 120
        }
        if (this.club.nummoves === undefined) {
          this.club.nummoves = 1
        }
        this.numMoves = parseInt(this.club.nummoves) // (parseInt(this.club.nummoves) * 2) - 1
        this.timeMove = parseInt(this.club.timemove) // (parseInt(this.club.nummoves) * 2) - 1
        this.titleFen = this.club.title
        this.handMoves = 0
        if (this.club.pgn !== undefined && this.club.pgn.length > 0) {
          var Width = 500
          if (document.getElementById('clubBoard') !== undefined) {
            Width = document.getElementById('clubBoard').clientWidth
          }
          var pgnBoard = 0
          var pos = 'end'
          var start = fen !== undefined ? fen : ''
          this.club.pgn = this.club.pgn.split('"]').join('"]\n')
          this.club.pgn = this.club.pgn.split('{}').join('')
          var headers = this.parse_pgn_header(this.club.pgn)
          if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
            pos = fen !== undefined ? fen : 'end'
            if (!this.hasBody(this.club.pgn)) {
              start = ''
              pos = headers['FEN']
            }
            if (pos === headers['FEN']) {
              start = ''
            }
          }
          if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
            start = ''
            pos = fen
          }
          if (fen === headers['FEN']) {
            pos = headers['FEN']
          }
          // window.alert(start + headers['FEN'])
          if (document.getElementById('pgnComment')) {
            document.getElementById('pgnComment').textContent = ''
          }
          var winWidth = Math.min(window.innerWidth, window.outerWidth)
          pgnBoard = window.pgnEdit({inner: 'clubBoard', comment: 'pgnComment'}, {pgn: this.club.pgn, position: pos, startPlay: start, width: Width, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true})
          this.ground = pgnBoard.board
          this.chess = pgnBoard.chess
          window.pgnBoardBase = pgnBoard.boardBase
          if (document.getElementById('clubBoard')) {
            document.getElementById('clubBoard').style.height = Width + 'px'
            document.getElementById('clubBoard').style.width = Width + 'px'
          }
          var options = {
            orientation: 'white',
            movable: {
              free: false,
              color: 'both',
              dests: this.chessToDests(this.chess),
              dropOff: 'revert',
              showDests: true,
              events: {
                after: this.onMove
              }
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            drawable: {
              enabled: true,
              visible: true
            }
          }
          // window.alert(pgnBoard.boardBase.getPgn().write_pgn())
          // window.alert(JSON.stringify(pgnBoard.boardBase.getPgn().getMove(0)))
          this.ground.set(options)
          this.userColor = this.chess.turn() === 'w' ? 'white' : 'black'
          this.chessToColor(this.chess)
          // this.movePC(this.turn)
        } else {
          if (fen) {
            this.chess.load(fen/* + ' ' + 'w KQ - 21 20'*/)
          } else {
            this.chess.load('8/2k5/8/8/6P1/8/8/4K3 w - - 0 1')
          }
          this.ground.set({
            fen: this.chess.fen(),
            turnColor: this.chessToColor(this.chess),
            movable: {
              color: this.chessToColor(this.chess),
              dests: this.chessToDests(this.chess)
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            drawable: {
              enabled: true,
              visible: true
            }
          })
          this.userColor = this.chess.turn() === 'w' ? 'white' : 'black'
          this.movePC(this.turn)
        }
        this.countDown()
      } catch (error) {
        // this.toast('<span>' + 'Error LoadClub: ' + error + '</span>', 3000)
        console.error('<span>' + 'Error LoadClub: ' + error + '</span>', 3000)
      }
    },
    resultado () {
      this.resultadoNext()
    },
    pista () {
      // window.alert('pista')
      this.pistaNext()
    },
    isFinish (chess) {
      // clearInterval(timesColor)
      return chess.game_over()
    },
    reintent () {
      clearInterval(timesColor)
      this.mate = false
      this.loadClub(this.club.feninit)
    }
  },
  beforeDestroy () {
    if (this.stockfish !== null && this.stockfish !== undefined) {
      // window.alert('Parando motor de evaluación')
      this.stockfish.close()
      this.stockfish = null
    }
  },
  ready () {
    // window.alert('Stockfish')
    try {
      // Garbochess.ResetGame()
      // window.alert('Arrancando motor de evaluación')
      this.stockfish = EngineGame.engineGame({book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js'})
      // var baseTime = 1 * 60
      // var inc = 1
      // var level = (parseFloat(this.board.elo) / 100) - 4
      var skill = 20 // 0 600 --> 10 1600 --> 20 --> 2600
      this.stockfish.reset()
      // this.stockfish.setTime(parseFloat(this.time.white), this.time.incremento)
      this.stockfish.setSkillLevel(skill)
      this.stockfish.setPlayerColor(this.orientation)
      this.stockfish.setDisplayScore(true)
      this.stockfish.setOwnBook(false)
      this.stockfish.start()
      var options = {
        orientation: 'white',
        movable: {
          free: false,
          color: 'both',
          dests: this.chessToDests(this.chess),
          dropOff: 'revert',
          showDests: true,
          events: {
            after: this.onMove
          }
        },
        highlight: {
          lastMove: true,       // add last-move class to squares
          check: true          // add check class to squares
        },
        drawable: {
          enabled: true,
          visible: true
        }
      }
      window.addEventListener('resize', this.onResize)
      // window.alert(classBoard)
      setTimeout(function () {
        // this.ground = Chessground(document.getElementById('clubBoard'), options)
        var pgnBoard = 0
        // window.alert(this.pgn)
        // var PgnNew = this.club.pgn.split('"]').join('"]\n')
        // PgnNew = PgnNew.split('{}').join('')
        // window.alert(PgnNew)
        if (document.getElementById('pgnComment') !== undefined) {
          document.getElementById('pgnComment').textContent = ''
        }
        var winWidth = Math.min(window.innerWidth, window.outerWidth)
        pgnBoard = window.pgnEdit({inner: 'clubBoard', comment: 'pgnComment'}, {showCoords: true, width: Width, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true})
        this.ground = pgnBoard.board
        window.pgnBoardBase = pgnBoard.boardBase
        this.ground.set(options)
        if (document.getElementById('clubBoard') !== undefined) {
          var Width = document.getElementById('clubBoard').clientWidth
          document.getElementById('clubBoard').style.height = Width + 'px'
          document.getElementById('clubBoard').style.width = Width + 'px'
        }
        // getFromLocalStorage
        // console.log('cargando board')
        this.loadClub()
      }.bind(this), 10)
    } catch (error) {
      // this.toast('<span>' + 'Error (ready club): ' + error + '</span>', 3000)
      console.error('<span>' + 'Error (ready club): ' + error + '</span>', 3000)
    }
  },
  watch: {
    club (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.loadClub(newVal.feninit)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../static/libs/simplechessboard.min.css';
h1 {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// club.vue?8be89a3e